<template>
  <div>
  <div class="container mt-4" v-if="errortype">
      <div class="alert alert-danger">{{ errortype | translate('msg') }}</div>
    </div>
  <form @submit.prevent="emitSave" id="coverCategoryTableAddEditDialog " class="scrollable-container">
    <h4 class="mb-4">{{ "ADD" | translate }}</h4>

    <div class="form-group" id="coverCategoryTableAddEditDialog-formGroup-CoverType">
      <label
        >{{ "CoverType" | translate }} <span class="asterisk">*</span></label
      >
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="coverCategory.coverType"
        required
        :disabled="Boolean(edited)"
        id="coverCategoryTableAddEditDialog-formGroup-CoverType-input"
      />
    </div>

    <div class="form-group" id="coverCategoryTableAddEditDialog-formGroup-Category">
      <label>{{ "Category" | translate }}</label>
      <select class="form-control form-control-sm" v-model="coverCategory.category"
      id="coverCategoryTableAddEditDialog-formGroup-Category-select">
        <option value="MAIN" id="coverCategoryTableAddEditDialog-select-option-MAIN-" >Main</option>
        <option value="ADDITIONAL_MAIN" id="coverCategoryTableAddEditDialog-select-option-ADDITIONAL_MAIN">Additional Main</option>
        <option value="SUB" id="coverCategoryTableAddEditDialog-select-optioN-SUB">Sub</option>
      </select>
    </div>

    <div class="form-group" id="coverCategoryTableAddEditDialog-formGroup-Omschrijving">
    <label>{{ 'Omschrijving' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="coverCategory.description"
           id="coverCategoryTableAddEditDialog-formGroup-Omschrijving-input">
  </div>

  <div class="form-group" id="coverCategoryTableAddEditDialog-FormGroup-backoffciecodeincoming" >
    <label>{{ 'BACKOFFICE_CODE_INCOMING' | translate }}</label>
    <div v-for="(code, index) in coverCategory.backofficeCodeIncoming" :key="index" class="form-group position-relative d-flex align-items-center">
        <input type="text"
              class="form-control form-control-sm"
              v-model="coverCategory.backofficeCodeIncoming[index]"
              @input="updateBackofficeCodeIncoming(index, $event.target.value)"
              :id="'coverCategoryTableAddEditDialog-oid-input-' + index"
              style="flex-grow: 1;">
          <button type="button" @click="removeBackofficeCode(index)" class="btn btn-danger btn-sm ms-2">
            <i class="fas fa-times"></i>
          </button>
    </div>
  <button class="btn btn-link" type="button" @click="addNewBackofficeCode">Add New Code</button>
  </div>
  <div class="form-group" id="coverCategoryTableAddEditDialog-FormGroup-backofficecodeoutgoing">
    <label>{{ 'BACKOFFICE_CODE_OUTGOING' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="coverCategory.backofficeCodeOutgoing"
           id="coverCategoryTableAddEditDialog-oid-input">
  </div>
  <div class="form-group" id="coverCategoryTableAddEditDialog-FormGroup-afdcode">
    <label>{{ 'AFD_CODE' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="coverCategory.afdCode"
           id="coverCategoryTableAddEditDialog-oid-input">
  </div>

    <div class="form-group" id="coverCategoryTableAddEditDialog-FormGroup-enabled">
    <label>{{ 'Enabled' | translate }}</label>
    <input type="checkbox"
           class="form-control form-control-sm"
           v-model="coverCategory.enabled"
           id="coverCategoryTableAddEditDialog-enabled-input">
  </div>

    <div class="mt-4 text-right" id="coverCategoryTableAddEditDialog-formGroup-buttons">
      <button class="btn btn-link" type="button" @click="emitClose"
      id="coverCategoryTableAddEditDialog-closeButton">
        {{ "CLOSE" | translate }}
      </button>

      <button class="btn btn-primary" type="submit" :disabled="!isFormValid"
      id="coverCategoryTableAddEditDialog-addButton">
        {{ "ADD" | translate }}
      </button>
    </div>
  </form>
</div>
</template>

<script>
export default {
  props: ['edited', 'errortype'],
  data() {
    return {
      coverCategory: {
        backofficeCodeIncoming: []
      }
    };
  },
  computed: {
    isFormValid() {
      return this.coverCategory.coverType;
    }
  },
  methods: {
    emitSave() {
      this.$emit(this.edited ? 'update' : 'save', this.coverCategory);
      this.resetCoverCategory();
    },
    emitClose() {
      this.$emit('close');
      this.resetCoverCategory();
    },
    updateBackofficeCodeIncoming(index, value) {
      this.$set(this.coverCategory.backofficeCodeIncoming, index, value);
    },
    addNewBackofficeCode() {
      this.coverCategory.backofficeCodeIncoming.push('');
    },
    resetCoverCategory() {
      this.coverCategory = { backofficeCodeIncoming: [] };
      this.edited = false;
    },
    removeBackofficeCode(index) {
      this.coverCategory.backofficeCodeIncoming.splice(index, 1);
    }
  },
  watch: {
    edited(newVal) {
      // Merge newVal properties with default structure to avoid undefined issues
      this.coverCategory = {
        backofficeCodeIncoming: newVal.backofficeCodeIncoming || [],
        coverType: newVal.coverType || '',
        description: newVal.description || '',
        category: newVal.category || '',
        enabled: newVal.enabled || '',
        code: newVal.code || '',
        backofficeCodeOutgoing: newVal.backofficeCodeOutgoing || '',
        afdCode: newVal.afdCode || ''
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}

.position-relative {
  position: relative;
}

.btn-danger {
  border: none;
  background-color: #dc3545;
  color: white;
  padding: 0.25rem 0.5rem;
}

.btn-danger:hover {
  background-color: #c82333;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.ms-2 {
  margin-left: 0.5rem;
}

.scrollable-container {
  max-height: 500px; 
  overflow-y: auto; 
  border-radius: 4px; 
}

</style>



// WEBPACK FOOTER //
// src/components/admin/cover-category/CoverCategoryAddEditDialog.vue